import React from "react";
import PropTypes from "prop-types";
import startCase from "lodash/startCase";

const Label = ({ label, error, customClasses, formatter }) => {
  let labelClasses = customClasses;
  if (error) {
    labelClasses += " color-error";
  }

  return (
    <label htmlFor={label} className={labelClasses}>
      {formatter ? formatter(label) : startCase(label)}
    </label>
  );
};

Label.propTypes = {
  label: PropTypes.string,
  formatter: PropTypes.func,
  customClasses: PropTypes.string,
  error: PropTypes.bool
};

Label.defaultProps = {
  customClasses: "f5 fw5 db pb2 pb3-ns",
  error: false
};

export default Label;
